export default __webpack_public_path__ + "static/media/sidebar_ic.515b7cbc.svg";